module.exports = {
  nowSelling: {
    active: true,
    label: 'Now Selling',
    livingOption: {
      active: true,
      label: 'Building'
    },
    subsectionGroup: {
      active: true,
      label: 'Floor Group'
    },
    subsection: {
      active: true,
      label: 'Floor'
    },
    property: {
      active: true,
      label: 'Apartment'
    },
    dwelling: {
      active: true,
      label: 'Apartment Design'
    },
    package: {
      active: false,
      label: 'House and Land Package'
    }
  }
}